import component from './item.vue'

export default component
